export const FINANCE_PEOPLE = {
  ceo: "Madeleine Redfern",
  seniorDirector: "Shelley Stacey",
  programLead: "Madison Coppola",
  nwacAdministrator: "Priya Singh",
  innovationLead: "Samir Deslauriers",
  monitoringLead: "Jordan Rivers",
};

export const FINANCE_POT_HIERARCHY = [
    {
        id: "nwac-master",
        parentId: null,
        name: "NWAC Master ISET Budget",
        code: "GL-5000",
        nodeType: "Funding envelope",
        approved: 2_000_000,
        adjusted: 2_075_000,
        committed: 1_692_000,
        actual: 1_598_000,
        forecast: 2_064_000,
        adminShare: 635_000,
        owner: FINANCE_PEOPLE.ceo,
    },
    {
        id: "nwac-admin",
        parentId: "nwac-master",
        name: "NWAC Administration",
        code: "GL-5100",
        nodeType: "Cost centre",
        approved: 280_000,
        adjusted: 295_000,
        committed: 240_000,
        actual: 225_000,
        forecast: 295_000,
        adminShare: 280_000,
        owner: FINANCE_PEOPLE.seniorDirector,
    },
    {
        id: "ptma-bc",
        parentId: "nwac-master",
        name: "PTMA British Columbia",
        code: "PTMA-BC",
        nodeType: "Region (PTMA)",
        approved: 380_000,
        adjusted: 392_000,
        committed: 335_000,
        actual: 318_000,
        forecast: 395_000,
        adminShare: 80_000,
        owner: "BC PTMA Finance Lead",
    },
    {
        id: "ptma-bc-admin",
        parentId: "ptma-bc",
        name: "BC Administration & Stewardship",
        code: "GL-BC-6100",
        nodeType: "Administration",
        approved: 80_000,
        adjusted: 82_000,
        committed: 70_000,
        actual: 66_000,
        forecast: 82_000,
        adminShare: 80_000,
        owner: FINANCE_PEOPLE.nwacAdministrator,
    },
    {
        id: "ptma-bc-client",
        parentId: "ptma-bc",
        name: "BC Client Services",
        code: "GL-BC-7100",
        nodeType: "Client delivery",
        approved: 300_000,
        adjusted: 310_000,
        committed: 265_000,
        actual: 252_000,
        forecast: 313_000,
        adminShare: 0,
        owner: FINANCE_PEOPLE.programLead,
    },
    {
        id: "ptma-ab",
        parentId: "nwac-master",
        name: "PTMA Alberta",
        code: "PTMA-AB",
        nodeType: "Region (PTMA)",
        approved: 340_000,
        adjusted: 352_000,
        committed: 290_000,
        actual: 276_000,
        forecast: 348_000,
        adminShare: 70_000,
        owner: "Alberta PTMA Finance",
    },
    {
        id: "ptma-ab-admin",
        parentId: "ptma-ab",
        name: "Alberta Administration & Stewardship",
        code: "GL-AB-6100",
        nodeType: "Administration",
        approved: 70_000,
        adjusted: 72_000,
        committed: 61_000,
        actual: 58_000,
        forecast: 70_000,
        adminShare: 70_000,
        owner: FINANCE_PEOPLE.nwacAdministrator,
    },
    {
        id: "ptma-ab-client",
        parentId: "ptma-ab",
        name: "Alberta Client Services",
        code: "GL-AB-7100",
        nodeType: "Client delivery",
        approved: 270_000,
        adjusted: 280_000,
        committed: 229_000,
        actual: 218_000,
        forecast: 278_000,
        adminShare: 0,
        owner: FINANCE_PEOPLE.programLead,
    },
    {
        id: "ptma-on",
        parentId: "nwac-master",
        name: "PTMA Ontario",
        code: "PTMA-ON",
        nodeType: "Region (PTMA)",
        approved: 400_000,
        adjusted: 412_000,
        committed: 332_000,
        actual: 310_000,
        forecast: 408_000,
        adminShare: 85_000,
        owner: "Ontario PTMA Finance",
    },
    {
        id: "ptma-on-admin",
        parentId: "ptma-on",
        name: "Ontario Administration & Stewardship",
        code: "GL-ON-6100",
        nodeType: "Administration",
        approved: 85_000,
        adjusted: 88_000,
        committed: 75_000,
        actual: 69_000,
        forecast: 86_000,
        adminShare: 85_000,
        owner: FINANCE_PEOPLE.nwacAdministrator,
    },
    {
        id: "ptma-on-client",
        parentId: "ptma-on",
        name: "Ontario Client Services",
        code: "GL-ON-7100",
        nodeType: "Client delivery",
        approved: 315_000,
        adjusted: 324_000,
        committed: 257_000,
        actual: 241_000,
        forecast: 322_000,
        adminShare: 0,
        owner: FINANCE_PEOPLE.programLead,
    },
    {
        id: "ptma-prairies",
        parentId: "nwac-master",
        name: "PTMA Prairies (MB/SK)",
        code: "PTMA-PRA",
        nodeType: "Region (PTMA)",
        approved: 260_000,
        adjusted: 268_000,
        committed: 209_000,
        actual: 196_000,
        forecast: 266_000,
        adminShare: 55_000,
        owner: "Prairies PTMA Finance",
    },
    {
        id: "ptma-prairies-admin",
        parentId: "ptma-prairies",
        name: "Prairies Administration & Stewardship",
        code: "GL-PRA-6100",
        nodeType: "Administration",
        approved: 55_000,
        adjusted: 56_000,
        committed: 46_000,
        actual: 43_000,
        forecast: 55_000,
        adminShare: 55_000,
        owner: FINANCE_PEOPLE.nwacAdministrator,
    },
    {
        id: "ptma-prairies-client",
        parentId: "ptma-prairies",
        name: "Prairies Client Services",
        code: "GL-PRA-7100",
        nodeType: "Client delivery",
        approved: 205_000,
        adjusted: 212_000,
        committed: 163_000,
        actual: 153_000,
        forecast: 211_000,
        adminShare: 0,
        owner: FINANCE_PEOPLE.programLead,
    },
    {
        id: "ptma-atlantic",
        parentId: "nwac-master",
        name: "PTMA Atlantic",
        code: "PTMA-ATL",
        nodeType: "Region (PTMA)",
        approved: 180_000,
        adjusted: 186_000,
        committed: 152_000,
        actual: 143_000,
        forecast: 184_000,
        adminShare: 35_000,
        owner: "Atlantic PTMA Finance",
    },
    {
        id: "ptma-atlantic-admin",
        parentId: "ptma-atlantic",
        name: "Atlantic Administration & Stewardship",
        code: "GL-ATL-6100",
        nodeType: "Administration",
        approved: 35_000,
        adjusted: 36_000,
        committed: 30_000,
        actual: 28_000,
        forecast: 35_000,
        adminShare: 35_000,
        owner: FINANCE_PEOPLE.nwacAdministrator,
    },
    {
        id: "ptma-atlantic-client",
        parentId: "ptma-atlantic",
        name: "Atlantic Client Services",
        code: "GL-ATL-7100",
        nodeType: "Client delivery",
        approved: 145_000,
        adjusted: 150_000,
        committed: 122_000,
        actual: 115_000,
        forecast: 149_000,
        adminShare: 0,
        owner: FINANCE_PEOPLE.programLead,
    },
    {
        id: "ptma-northern",
        parentId: "nwac-master",
        name: "PTMA Northern (YT/NT/NU)",
        code: "PTMA-NTH",
        nodeType: "Region (PTMA)",
        approved: 160_000,
        adjusted: 170_000,
        committed: 134_000,
        actual: 130_000,
        forecast: 168_000,
        adminShare: 30_000,
        owner: "Northern PTMA Finance",
    },
    {
        id: "ptma-northern-admin",
        parentId: "ptma-northern",
        name: "Northern Administration & Stewardship",
        code: "GL-NTH-6100",
        nodeType: "Administration",
        approved: 30_000,
        adjusted: 32_000,
        committed: 25_000,
        actual: 23_000,
        forecast: 31_000,
        adminShare: 30_000,
        owner: FINANCE_PEOPLE.nwacAdministrator,
    },
    {
        id: "ptma-northern-client",
        parentId: "ptma-northern",
        name: "Northern Client Services",
        code: "GL-NTH-7100",
        nodeType: "Client delivery",
        approved: 130_000,
        adjusted: 138_000,
        committed: 109_000,
        actual: 107_000,
        forecast: 137_000,
        adminShare: 0,
        owner: FINANCE_PEOPLE.monitoringLead,
    },
];


export const FINANCE_POT_DETAILS = {
  "nwac-master": {
    title: "NWAC Master ISET Budget",
    owner: FINANCE_PEOPLE.ceo,
    description:
      "Master funding envelope covering NWAC administration and all PTMA contribution agreements. Totals align to the 2024-25 contribution agreement amendment.",
    glAccount: "GL-5000",
    adminPct: "30.6%",
    policyNotes:
      "Track aggregate administrative allowance (NWAC + PTMA stewardship) to remain within agreement cap. Reference Appendix D for flat-rate logic.",
    approvals: [
      { id: "NWAC-BRD-25-01", type: "Board ratification", date: "2025-03-28", owner: "NWAC Board of Directors" },
      { id: "ESDC-AG-2025", type: "ESDC amendment", date: "2025-04-05", owner: "ESDC ISET Directorate" },
    ],
    adjustments: [
      {
        id: "ADJ-2401",
        date: "2025-04-30",
        user: FINANCE_PEOPLE.nwacAdministrator,
        amount: 75_000,
        type: "Increase",
        reason: "Additional PTMA top-ups released after Q1 variance review.",
      },
    ],
    evidence: [
      { id: "DOC-MASTER-001", label: "Contribution agreement amendment", href: "/files/finance/nwac-master-agreement.pdf" },
      { id: "DOC-MASTER-014", label: "Q1 variance briefing note", href: "/files/finance/q1-variance-brief.pdf" },
    ],
  },
  "nwac-admin": {
    title: "NWAC Administration",
    owner: FINANCE_PEOPLE.seniorDirector,
    description:
      "Core NWAC administration costs (salaries, benefits, occupancy) associated with national program management and compliance.",
    glAccount: "GL-5100",
    adminPct: "100%",
    policyNotes:
      "Remains within the negotiated 15% flat-rate cap. Any increase requires written approval from ESDC (Appendix D).",
    approvals: [
      { id: "NWAC-FIN-24-07", type: "Finance committee approval", date: "2024-12-12", owner: "Finance Committee" },
    ],
    adjustments: [
      {
        id: "ADJ-2403",
        date: "2025-01-15",
        user: FINANCE_PEOPLE.nwacAdministrator,
        amount: -10_000,
        type: "Decrease",
        reason: "Shifted to PTMA top-up reserve after salary savings identified.",
      },
    ],
    evidence: [
      { id: "DOC-NWAC-ADM-01", label: "Salary allocation summary", href: "/files/finance/nwac-adm-salary.xlsx" },
      { id: "DOC-NWAC-ADM-08", label: "Lease cost schedule", href: "/files/finance/lease-schedule.pdf" },
    ],
  },
  "ptma-bc": {
    title: "PTMA British Columbia Agreement",
    owner: "BC PTMA Finance Lead",
    description:
      "Workplan funding for BC PTMA with explicit split between administration and client service delivery. Includes GL mapping for province-specific reporting.",
    glAccount: "PTMA-BC",
    adminPct: "20.4%",
    policyNotes:
      "Ensure admin costs do not exceed delegated 21%. Top-up trigger at 95% client commitment (see Allocation Top-Up widget).",
    approvals: [
      { id: "PTMA-BC-AGR-2025", type: "PTMA agreement", date: "2025-03-15", owner: "BC PTMA Board" },
    ],
    adjustments: [
      {
        id: "ADJ-BC-2402",
        date: "2025-05-03",
        user: FINANCE_PEOPLE.programLead,
        amount: 12_000,
        type: "Increase",
        reason: "Additional travel supports for northern coastal communities.",
      },
    ],
    evidence: [
      { id: "DOC-BC-AGR-01", label: "BC PTMA signed agreement", href: "/files/finance/bc-ptma-agreement.pdf" },
    ],
  },
  "ptma-bc-client": {
    title: "BC Client Services",
    owner: FINANCE_PEOPLE.programLead,
    description:
      "Client-focused supports (training, wage subsidies, childcare) delivered through BC PTMA partners.",
    glAccount: "GL-BC-7100",
    adminPct: "0%",
    policyNotes:
      "Commitments beyond 310K require reallocation approval. Monitor cultural supports line to ensure documentation is complete.",
    approvals: [
      { id: "PTMA-BC-CS-01", type: "PTMA workplan endorsement", date: "2025-03-22", owner: "BC Regional Council" },
    ],
    adjustments: [
      {
        id: "ADJ-BC-CS-05",
        date: "2025-06-11",
        user: FINANCE_PEOPLE.nwacAdministrator,
        amount: 18_000,
        type: "Top-up",
        reason: "Client commitments exceeded 95% threshold ahead of summer cohort.",
      },
    ],
    evidence: [
      { id: "DOC-BC-CS-09", label: "Client commitment tracker", href: "/files/finance/bc-commitments.xlsx" },
    ],
  },
  "ptma-ab": {
    title: "PTMA Alberta Agreement",
    owner: "Alberta PTMA Finance",
    description:
      "Funding for Alberta PTMA with GL mapping to distinguish stewardship vs. client delivery lines.",
    glAccount: "PTMA-AB",
    adminPct: "19.9%",
    policyNotes:
      "Field offices in Edmonton and Calgary share the admin envelope; ensure allocations are tagged correctly in GL uploads.",
    approvals: [
      { id: "PTMA-AB-AGR-2025", type: "PTMA agreement", date: "2025-03-20", owner: "Alberta PTMA Board" },
    ],
    adjustments: [
      {
        id: "ADJ-AB-2401",
        date: "2025-05-18",
        user: FINANCE_PEOPLE.nwacAdministrator,
        amount: -8_000,
        type: "Reallocation",
        reason: "Shifted to northern PTMA technology supports after uptake slowed.",
      },
    ],
    evidence: [
      { id: "DOC-AB-AGR-02", label: "AB PTMA workplan", href: "/files/finance/ab-workplan.pdf" },
    ],
  },
  "ptma-on": {
    title: "PTMA Ontario Agreement",
    owner: "Ontario PTMA Finance",
    description:
      "Largest PTMA envelope supporting multiple urban centres. Includes GL designations for admin, client supports, and innovation pilots.",
    glAccount: "PTMA-ON",
    adminPct: "21.4%",
    policyNotes:
      "Innovation pilots draw on client services GL. Track separate commitment ledger for Toronto pilot.",
    approvals: [
      { id: "PTMA-ON-AGR-2025", type: "PTMA agreement", date: "2025-03-18", owner: "Ontario PTMA Board" },
    ],
    adjustments: [
      {
        id: "ADJ-ON-2404",
        date: "2025-06-08",
        user: FINANCE_PEOPLE.programLead,
        amount: 22_000,
        type: "Increase",
        reason: "Expanded integrated services pilot with municipal partners.",
      },
    ],
    evidence: [
      { id: "DOC-ON-AGR-03", label: "Ontario PTMA GL crosswalk", href: "/files/finance/on-gl-crosswalk.xlsx" },
    ],
  },
  "ptma-prairies": {
    title: "PTMA Prairies (MB/SK)",
    owner: "Prairies PTMA Finance",
    description:
      "Shared workplan for Manitoba and Saskatchewan PTMAs with blended admin/client split.",
    glAccount: "PTMA-PRA",
    adminPct: "20.9%",
    policyNotes:
      "Travel-heavy program; confirm evidence for mileage reimbursements quarterly.",
    approvals: [
      { id: "PTMA-PRA-AGR-2025", type: "PTMA agreement", date: "2025-03-12", owner: "Prairies PTMA Council" },
    ],
    adjustments: [
      {
        id: "ADJ-PRA-2401",
        date: "2025-04-27",
        user: FINANCE_PEOPLE.nwacAdministrator,
        amount: 9_000,
        type: "Increase",
        reason: "Cover additional outreach sessions requested by Monitoring.",
      },
    ],
    evidence: [
      { id: "DOC-PRA-AGR-01", label: "Prairies outreach plan", href: "/files/finance/prairies-outreach.pdf" },
    ],
  },
  "ptma-atlantic": {
    title: "PTMA Atlantic Agreement",
    owner: "Atlantic PTMA Finance",
    description:
      "Workplan for Atlantic PTMAs with emphasis on childcare and community-based wraparound supports.",
    glAccount: "PTMA-ATL",
    adminPct: "18.8%",
    policyNotes:
      "Childcare reimbursements require weekly uploads. Trigger top-up when client commitments exceed 92%.",
    approvals: [
      { id: "PTMA-ATL-AGR-2025", type: "PTMA agreement", date: "2025-03-09", owner: "Atlantic PTMA Council" },
    ],
    adjustments: [
      {
        id: "ADJ-ATL-2401",
        date: "2025-05-25",
        user: FINANCE_PEOPLE.programLead,
        amount: -6_000,
        type: "Reallocation",
        reason: "Shift to BC childcare supports after uptake spike in Vancouver.",
      },
    ],
    evidence: [
      { id: "DOC-ATL-AGR-03", label: "Atlantic childcare roster", href: "/files/finance/atl-childcare.xlsx" },
    ],
  },
  "ptma-northern": {
    title: "PTMA Northern (YT/NT/NU)",
    owner: "Northern PTMA Finance",
    description:
      "Support for northern PTMAs with focus on remote delivery, connectivity, and wellness travel.",
    glAccount: "PTMA-NTH",
    adminPct: "17.6%",
    policyNotes:
      "Satellite connectivity invoices must be logged monthly. Maintain backup documentation for medevac travel.",
    approvals: [
      { id: "PTMA-NTH-AGR-2025", type: "PTMA agreement", date: "2025-03-05", owner: "Northern PTMA Council" },
    ],
    adjustments: [
      {
        id: "ADJ-NTH-2402",
        date: "2025-06-02",
        user: FINANCE_PEOPLE.monitoringLead,
        amount: 7_500,
        type: "Increase",
        reason: "Added telehealth support in Nunavut after monitoring recommendation.",
      },
    ],
    evidence: [
      { id: "DOC-NTH-AGR-02", label: "Northern connectivity contract", href: "/files/finance/northern-connectivity.pdf" },
    ],
  },
};


export const FINANCE_PRIMARY_POT_OPTIONS = [
  { value: "nwac-admin", label: "NWAC Administration" },
  { value: "ptma-bc-client", label: "PTMA British Columbia � Client Services" },
  { value: "ptma-ab-client", label: "PTMA Alberta � Client Services" },
  { value: "ptma-on-client", label: "PTMA Ontario � Client Services" },
  { value: "ptma-prairies-client", label: "PTMA Prairies � Client Services" },
  { value: "ptma-atlantic-client", label: "PTMA Atlantic � Client Services" },
  { value: "ptma-northern-client", label: "PTMA Northern � Client Services" },
];


export const FINANCE_POT_METRICS = {
  "nwac-admin": { available: 55_000, adminPct: 14.8, forecastVariance: 0 },
  "ptma-bc-admin": { available: 12_000, adminPct: 20.7, forecastVariance: 0 },
  "ptma-bc-client": { available: 45_000, adminPct: 4.3, forecastVariance: 1.0 },
  "ptma-ab-admin": { available: 11_000, adminPct: 20.5, forecastVariance: -0.3 },
  "ptma-ab-client": { available: 51_000, adminPct: 4.1, forecastVariance: -0.7 },
  "ptma-on-admin": { available: 13_000, adminPct: 21.4, forecastVariance: -0.5 },
  "ptma-on-client": { available: 67_000, adminPct: 4.2, forecastVariance: -0.6 },
  "ptma-prairies-admin": { available: 10_000, adminPct: 21.0, forecastVariance: -0.2 },
  "ptma-prairies-client": { available: 49_000, adminPct: 4.0, forecastVariance: -0.5 },
  "ptma-atlantic-admin": { available: 6_000, adminPct: 19.4, forecastVariance: -0.3 },
  "ptma-atlantic-client": { available: 28_000, adminPct: 4.1, forecastVariance: -0.7 },
  "ptma-northern-admin": { available: 7_000, adminPct: 18.8, forecastVariance: -0.4 },
  "ptma-northern-client": { available: 29_000, adminPct: 3.9, forecastVariance: -0.7 },
};


export const FINANCE_POT_MAP = FINANCE_POT_HIERARCHY.reduce((acc, pot) => {
  acc[pot.id] = pot;
  return acc;
}, {});

